import React from 'react';
import Testimonial from '../../components/testimonial/Testimonial';
import WhyChooseUs from '../../components/whychooseus/WhyChooseUs';
import Breadcrumb from '../common/Breadcrumb';
import Footer from '../common/Footer';
import Header from '../common/Header';
import { Helmet } from 'react-helmet';

function Dermaplaning() {
  return (
    <div>
      <Helmet>
        <title>Dermaplaning Treatment in Gurgaon | Swakaaya Aesthetics</title>
        <meta
          name='description'
          content='Smooth and brighten your skin with dermaplaning treatment in Gurgaon at Swakaaya. Safe exfoliation for radiant skin glow.'
        />
        <meta
          name='keywords'
          content='dermaplaning Gurgaon, exfoliation treatment Gurgaon, glowing skin Gurgaon'
        />
        <link
          rel='canonical'
          href='https://swakaaya.com/our-services/dermaplaning'
        />

        <meta
          property='og:title'
          content='Dermaplaning Treatment in Gurgaon | Swakaaya Aesthetics'
        />
        <meta
          property='og:description'
          content='Smooth and brighten your skin with dermaplaning treatment in Gurgaon at Swakaaya. Safe exfoliation for radiant skin glow.'
        />
        <meta
          property='og:url'
          content='https://swakaaya.com/our-services/dermaplaning'
        />
        <meta property='og:type' content='website' />
        <meta
          property='og:image'
          content='https://swakaaya.com/assets/images/logo.png'
        />

        <meta name='twitter:card' content='summary_large_image' />
        <meta
          name='twitter:title'
          content='Dermaplaning Treatment in Gurgaon | Swakaaya Aesthetics'
        />
        <meta
          name='twitter:description'
          content='Smooth and brighten your skin with dermaplaning treatment in Gurgaon at Swakaaya. Safe exfoliation for radiant skin glow.'
        />
        <meta
          name='twitter:image'
          content='https://swakaaya.com/assets/images/logo.png'
        />
      </Helmet>
      <Header />
      <Breadcrumb title={'Dermaplaning'} />
      <section className='section section-padding-02 '>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              <div className='service-content'>
                <div>
                  <div>
                    <h2>
                      <strong>DERMAPLANING</strong>
                    </h2>

                    <div>
                      <p>
                        Dermaplaning is a highly effective skin treatment that
                        gently exfoliates the skin to reveal a smoother,
                        brighter, and more even complexion. Unlike regular
                        scrubs or facials, Dermaplaning uses a specialized
                        medical blade to carefully remove dead skin cells and
                        fine vellus hair from the surface of the skin.
                      </p>
                      <p>
                        This procedure not only enhances skin texture but also
                        improves product absorption, helps makeup glide on
                        flawlessly, and promotes a fresh, youthful glow. It is
                        safe, painless, and suitable for most skin types.
                      </p>

                      <p>
                        <strong>THE DERMAPLANING PROCEDURE INCLUDES:</strong>
                      </p>
                      <ul>
                        <li>
                          The skin is first cleansed thoroughly to remove dirt,
                          makeup, and oil.
                        </li>
                        <li>
                          A sterile, medical-grade surgical blade is gently
                          glided across the skin at a precise angle.
                        </li>
                        <li>
                          This process removes the buildup of dead skin cells,
                          dull surface debris, and fine facial hair.
                        </li>
                        <li>
                          A soothing hydrating serum, mask, or moisturizer is
                          applied post-treatment to calm and nourish the skin.
                        </li>
                        <li>
                          Sunscreen is applied to protect the freshly exfoliated
                          skin.
                        </li>
                      </ul>
                      <p>
                        The session usually takes 30 to 45 minutes and has no
                        downtime, making it a quick and effective treatment for
                        instantly radiant skin.
                      </p>

                      <p>
                        <strong>HOW LONG DOES IT TAKE TO SHOW RESULTS?</strong>
                      </p>
                      <p>
                        Results are visible immediately after the first session
                        — the skin looks smoother, brighter, and feels
                        incredibly soft. With regular treatments, dermaplaning
                        helps in reducing dullness, improving skin texture, and
                        minimizing early signs of aging.
                      </p>

                      <p>
                        <strong>WHAT ARE THE BENEFITS OF DERMAPLANING?</strong>
                      </p>
                      <ul>
                        <li>Instantly smooth, soft, and glowing skin</li>
                        <li>Removes dead skin cells and peach fuzz</li>
                        <li>Improves absorption of skincare products</li>
                        <li>
                          Allows makeup to blend seamlessly for a flawless
                          finish
                        </li>
                        <li>Enhances skin texture and radiance</li>
                        <li>Safe, painless, and non-invasive procedure</li>
                      </ul>
                      <p>
                        For best results, Dermaplaning should be performed by
                        trained dermatologists or certified skin professionals
                        using sterile medical-grade tools.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <WhyChooseUs />
      <Testimonial />
      <Footer />
    </div>
  );
}

export default Dermaplaning;
